import { ReceptionServiceId } from '@dreryk/egabinet-private-medical-service-published-language-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../translations';

import { PractitionerReceptionServiceUpdateForm } from './PractitionerReceptionServiceUpdateForm';
import { PractitionerReceptionServiceUpdateFormLoader } from './PractitionerReceptionServiceUpdateForm.loader';
import { PractitionerReceptionServiceUpdateAction } from './PractitionerReceptionServiceUpdateModal.actions';

type PractitionerReceptionServiceUpdateModalProps = {
   readonly receptionServiceId: ReceptionServiceId;
   readonly practitionerId: number;
   readonly onSuccess: VoidFunction;
   readonly onClose: VoidFunction;
};

export const PractitionerReceptionServiceUpdateModal = (
   props: PractitionerReceptionServiceUpdateModalProps
): JSX.Element => {
   return (
      <Modal
         testId={'practitionerReceptionServiceUpdate'}
         title={receptionServiceTranslationKeys.update.modal.title}
         width={ModalWidth.HUGE}
      >
         <PractitionerReceptionServiceUpdateFormLoader
            receptionServiceId={props.receptionServiceId}
            practitionerId={props.practitionerId}
         >
            {({ receptionService, serviceLocations }) => (
               <PractitionerReceptionServiceUpdateForm
                  receptionService={receptionService}
                  serviceLocations={serviceLocations}
               >
                  {({ handleSubmit, formState }) => (
                     <>
                        <PractitionerReceptionServiceUpdateAction onSuccess={props.onSuccess}>
                           {({ updatePractitionerReceptionService }) => (
                              <ModalConfirmButton
                                 label={receptionServiceTranslationKeys.update.modal.confirm}
                                 onClick={handleSubmit(updatePractitionerReceptionService)}
                              />
                           )}
                        </PractitionerReceptionServiceUpdateAction>

                        <ModalCancelButton
                           label={commonTranslationKeys.cancel}
                           onClick={props.onClose}
                           shouldConfirmExit={formState.isDirty}
                        />
                        <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                     </>
                  )}
               </PractitionerReceptionServiceUpdateForm>
            )}
         </PractitionerReceptionServiceUpdateFormLoader>
      </Modal>
   );
};
